import Api from './api';

const VeiculosService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/veiculos/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/veiculos/buscar?${params}`)
        return response
    }
}

export default VeiculosService;